<template>
  <div class="login">
    <div class="userform">
      <div class="logoform">
        <div class="alogo"></div>
        <div class="content">OA系统</div>
      </div>
      <el-form class="loginform" :model="user" status-icon :rules="rules" ref="ruleForm">
        <el-form-item prop="nickname">
          <el-input v-model.number="user.nickname" prefix-icon="el-icon-user" :clearable="true" class="inputline"
            maxlength="40" @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input type="password" v-model="user.pwd" autocomplete="off" prefix-icon="el-icon-lock" :clearable="true"
            :show-password="true" class="inputline" maxlength="20" @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        nickname: '',
        pwd: '',
      },
      rules: {
        nickname: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 40, message: '长度在 3 到 40 个字符', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    // userTest().then(res => {
    //   console.log(res)
    // })
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login()
        } else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    login() {
      this.$store
        .dispatch("user/login", { nickname: this.user.nickname, pwd: this.user.pwd })
        .then(() => {
          // this.$store.dispatch('user/account')
          this.$router.push({
            path: this.$route.query.redirect || "/home"
          });
        })
        .catch(error => {
          console.warn(error);
        });
    }
  }
}
</script>

<style lang="scss">
.login {
  @extend %center;
  height: 100vh;
  background: $bg;
}

.userform {
  width: rem(700);
  // height: rem(700);
  padding: 0;
  // padding: rem(300) 0 0 0;
  box-sizing: border-box;
  background: #fff;
  // background: url(../assets/login.png) no-repeat 0 0 #fff;
  box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.1);
  border-radius: rem(16);
  @extend %center;

  .logoform {
    width: 100%;
    height: 240px;
    margin-bottom: 40px;
    border-radius: 20px 20px 0 0;
    background: $c;
    color: #fff;

    .alogo {
      width: 514px;
      height: 58px;
      display: block;
      margin: 60px auto 50px;
      background: url(../assets/alogo.png) no-repeat;
      background-size: contain;
    }

    .content {
      font-size: 28px;
    }
  }

  .loginform {
    width: 400px;

    .el-form-item__content {
      margin-bottom: 40px;
    }

    .inputline {
      input {
        border: 0 solid transparent;
        border-bottom: 1px solid #999;
        border-radius: 0;
        font-size: 20px;
      }

      .el-input__prefix {
        font-size: 28px;
        color: $c;
        transform: translate(-8px, -6px);
      }
    }

    .el-button {
      width: 400px;
      height: 50px;
      padding: 0;
      font: 24px/48px $font;
    }
  }
}
</style>